export default __webpack_public_path__ + "static/media/CAP3Nano-thumbnail-cc.171b1857.png";